import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NotificationMessageInfoDataService } from 'src/app/services/notification-message-info-data.service';
import { NotificationService } from 'src/app/services/notification-service';

@Component({
  selector: 'app-manage-otp-notification',
  templateUrl: './manage-otp-notification.component.html',
  styleUrls: ['./manage-otp-notification.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*', display: 'block', padding: '15px' })),
      transition('expanded <=> collapsed', animate('100ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ManageOtpNotificationComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild("searchInput", { static: true }) searchInput: ElementRef;
  filterOpen = false;
  data: any[] = [];
  form: FormGroup
  dataSource = new MatTableDataSource(this.data);
  displayedColumns: any[] = [
    "recipient",
    "OTP",
    "TimeStamp",
  ]
  searchText: any;

  constructor(
    private NotificationMessageInfoDataService: NotificationMessageInfoDataService,
    private FormBuilder: FormBuilder,
    private toast: NotificationService,
  ) { }

  ngOnInit(): void {
    this.form = this.FormBuilder.group({
      recipient: [null],
      // OTP: [null],
      // TimeStamp: [null],
      searchText:[null]

    })

    var payload: any = {};
    payload.onPageLoad = true;
    this.getData()
  }
  clearFilter() {
    var payload: any = {};
    payload.onPageLoad = true;
    this.getData()
    this.form.reset();
  }
  getData() {
    this.NotificationMessageInfoDataService.GetOtpNotificationMessage().subscribe((result) => {
      if (Array.isArray(result)) {
        this.data = result;
        this.dataSource = new MatTableDataSource(this.data);
        this.dataSource.paginator = this.paginator;
      }
      else {
        this.data = [];
      }
    })
  }


  search() {
    debugger
    const query = (this.form.value.searchText || '').trim().toLowerCase();
    this.data = this.data.filter(item =>
      item.recipient.toLowerCase().includes(query) ||
      item.otp.toString().includes(query)
    );
    this.dataSource = new MatTableDataSource(this.data);
    this.dataSource.paginator = this.paginator;

  }


  // var rawFormValue = this.form.getRawValue();
  // const from = rawFormValue.fromDate
  // const to = rawFormValue.endDate;

  // if (!from && !to) {
  //   this.toast.showError('Both From Date and To Date are required');
  //   return
  // }

  // if (to < from) {
  //   this.toast.showError('To Date must be greater than or equal to From Date');
  //   return
  // }


  // var payload: any = {};
  // payload.onPageLoad = false;
  // payload.fromDate = rawFormValue.fromDate
  //   ? new Date(rawFormValue.fromDate).toISOString()
  //   : null;

  // payload.endDate = rawFormValue.endDate
  //   ? new Date(rawFormValue.endDate).toISOString()
  //   : null;

  // payload.recipent = rawFormValue.recipent;
  // this.getData()

}
